/* Product-only Stamped fixes. Loaded by layout/theme.liquid. */
(() => {
  if (window.flycatcherStampedProductInitialized) return;
  window.flycatcherStampedProductInitialized = true;

  const rootSelector = '#stamped-main-widget, .stamped-product-reviews-badge';
  const metaSelector = 'meta[itemprop="ratingValue"], meta[itemprop="reviewCount"]';
  const bindings = new Map();

  function removeOrphanedMicrodata(root) {
    if (!(root instanceof Element)) return;
    if (root.matches(metaSelector)) {
      root.remove();
      return;
    }
    root.querySelectorAll(metaSelector).forEach((meta) => meta.remove());
  }

  function bindWidgets(scope = document) {
    const roots = [];
    if (scope.matches?.(rootSelector)) roots.push(scope);
    roots.push(...scope.querySelectorAll(rootSelector));

    roots.forEach((widget) => {
      if (bindings.has(widget)) return;
      const isMainWidget = widget.id === 'stamped-main-widget';
      let frame = 0;

      function updateQuestions() {
        frame = 0;
        const tab = widget.querySelector('#tab-questions');
        const messages = widget.querySelector('.stamped-messages');
        if (!tab || !messages) return;
        const display = tab.getAttribute('aria-selected') === 'true' ? 'none' : '';
        if (messages.style.display !== display) messages.style.display = display;
      }

      removeOrphanedMicrodata(widget);
      if (isMainWidget) updateQuestions();

      const observer = new MutationObserver((mutations) => {
        let updateNeeded = false;
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(removeOrphanedMicrodata);
            updateNeeded = updateNeeded || mutation.addedNodes.length > 0;
          } else if (mutation.target.id === 'tab-questions') {
            updateNeeded = true;
          }
        });
        if (isMainWidget && updateNeeded && !frame) {
          frame = requestAnimationFrame(updateQuestions);
        }
      });

      const options = { childList: true, subtree: true };
      if (isMainWidget) {
        options.attributes = true;
        options.attributeFilter = ['aria-selected'];
      }
      observer.observe(widget, options);
      bindings.set(widget, () => {
        observer.disconnect();
        if (frame) cancelAnimationFrame(frame);
        bindings.delete(widget);
      });
    });
  }

  function pruneDetachedWidgets() {
    bindings.forEach((dispose, widget) => {
      if (!widget.isConnected) dispose();
    });
  }

  bindWidgets();
  document.addEventListener('shopify:section:load', (event) => {
    pruneDetachedWidgets();
    bindWidgets(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    bindings.forEach((dispose, widget) => {
      if (event.target === widget || event.target.contains(widget)) dispose();
    });
  });
  document.addEventListener('quickview:loaded', () => {
    pruneDetachedWidgets();
    bindWidgets();
  });
})();
